import {CensusEquipmentStatusesEnum} from "../processes/massive_actions/CensusCooler/data/models/CensusEnums";
import {MappedSummaryWithFinalAction} from "./data/types/MappedSummaryWithFinalAction";

export const isUUID = (uuid: string): boolean => {
    //javascript regex to validate UUID
    const regex = new RegExp(
        "^[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12}$")
    return regex.test(uuid);
}


export const sortSummaryWithFinalAction = (
    firstSummary: MappedSummaryWithFinalAction,
    secondSummary: MappedSummaryWithFinalAction,
): number => {
    const firstStatus = firstSummary?.inventoryStatus;
    const secondStatus = secondSummary?.inventoryStatus;
    const firstStatusDetail = firstSummary?.inventoryStatusDetail;
    const secondStatusDetail = secondSummary?.inventoryStatusDetail;
    const firstReason = firstSummary?.inventoryStatusReason;
    const secondReason = secondSummary?.inventoryStatusReason;

    if (firstStatus === CensusEquipmentStatusesEnum.FAIL && secondStatus !== CensusEquipmentStatusesEnum.FAIL) {
        return -1;
    }
    if (firstStatus !== CensusEquipmentStatusesEnum.FAIL && secondStatus === CensusEquipmentStatusesEnum.FAIL) {
        return 1;
    }
    if (firstStatusDetail && !firstStatusDetail) {
        return -1;
    }
    if (!firstStatusDetail && secondStatusDetail) {
        return 1;
    }
    if (firstReason && !secondReason) {
        return -1;
    }
    if (!firstReason && secondReason) {
        return 1;
    }
    return 0;
};